import { render } from "./DisclaimerModal.vue?vue&type=template&id=736ce0de"
import script from "./DisclaimerModal.vue?vue&type=script&lang=js"
export * from "./DisclaimerModal.vue?vue&type=script&lang=js"

import "./DisclaimerModal.vue?vue&type=style&index=0&id=736ce0de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__